// Stylesheet
import "./SettingsMenu.css";

// import { AccessTime, ThreeDRotation } from '@material-ui/icons';
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import AssignmentRoundedIcon from "@material-ui/icons/AssignmentRounded";
import LockRoundedIcon from "@material-ui/icons/LockRounded";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { NavLink } from "react-router-dom";

import { useStateValue } from "../../config/AppContext";
// Assets
import Icons from "../Utilities/Icons";

const SettingsMenuComponent = (props: any) => {
  const { t } = useTranslation();
  const { SettingsIcons } = Icons;
  const { user, Methods } = useStateValue();
  const history = useHistory();
  if (!user || !Methods) return null;

  const profileRow: JSX.Element = (
    <NavLink to={"/settings/profile"} className="profile d-flex">
      <span className="icon">
        <img
          alt="profile"
          style={{ objectFit: "cover" }}
          src={user.photo ? user.photo.medium : SettingsIcons[0]}
          onError={(event) => {
            event.currentTarget.src = SettingsIcons[0];
            event.currentTarget.onerror = null;
            return true;
          }}
        />
      </span>
      <div className="ml-2">
        <p className="m-0">
          {user.first_name} {user.last_name}
        </p>
        <p className="email m-0" title={`${user.email}`}>
          {user.email.length > 30 ? `${user.email.slice(0, 28)}...` : `${user.email}`}
        </p>
      </div>
    </NavLink>
  );

  const logoutMenu: JSX.Element = (
    <li
      key={4}
      className="menu-item"
      onClick={() => Methods && Methods.handleLogout().then(() => history.push("/"))}
    >
      <hr style={{ margin: 0, marginBottom: 8 }} />
      <span className="icon logout">
        <img alt="logout" src={SettingsIcons[4]} />
      </span>
      {t("Logout")}
    </li>
  );
  const menus: string[] = ["Availability", "Statistics", "General"];

  const menuListRow: JSX.Element[] = [
    ...menus.map((menu, i) => {
      return (
        <li className="menu-item" key={i}>
          <NavLink to={`/settings/${menu}`}>
            <span className={`icon ${menu}`}>
              {/* <img alt={`${menu}`} src={SettingsIcons[i + 1]} /> */}
              {i === 0 ? (
                <AccessTimeIcon style={{ color: "white" }} />
              ) : i === 1 ? (
                <TrendingUpIcon style={{ color: "white" }} />
              ) : i === 2 ? (
                <AssignmentRoundedIcon style={{ color: "white" }} />
              ) : (
                <LockRoundedIcon />
              )}
            </span>
            {t(menu)}
          </NavLink>
        </li>
      );
    }),
    logoutMenu,
  ];

  return (
    <div id="SettingsMenu" onClick={props["close-menu"]}>
      <div className="row">{profileRow}</div>
      <div className="row">
        <h5 className="section-heading">{t("Settings")}</h5>
        <ul className="menu-list">{menuListRow}</ul>
      </div>
    </div>
  );
};

export default SettingsMenuComponent;
